import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import _ from 'lodash'
import { DataTablePagination } from '@/types/_'
import Apis from '@/Apis/_'

type Mode = 'CREATE' | 'EDIT'

type SetSuporteModal = {
  name: string,
  value: boolean,
}

type SuporteModal = {
  grupoEquipamento: boolean,
  equipamento: boolean,
}

interface EquipamentoHospital {
  id: string,
  nome: string,
  status: 'Ativo' | 'Removido',
  quantidade: number,
  hisId: string,
  grupoEquipamentoId: string,
}

interface GrupoEquipamentoHospital {
  id: string,
  nome: string,
  status: 'Ativo' | 'Removido',
  exibeApenasParaOBackoffice: boolean,
  hisId: string,
  hospitalId?: string,
  tipoGrupoEquipamento?: 'Robotica' | null,
}

@Module({ namespaced: true, name: 'SuporteEquipamentosStore' })
export default class SuporteEquipamentosStore extends VuexModule {
  public hospitalId: string = ''
  public searchEquipamento: string = ''
  public searchGrupoEquipamento: string = ''

  public mode: Mode = 'CREATE'

  public modal: SuporteModal = {
    grupoEquipamento: false,
    equipamento: false,
  }

  @Mutation
  setSearchEquipamento(val: string) {
    this.searchEquipamento = val
  }

  @Mutation
  setSearchGrupoEquipamento(val: string) {
    this.searchGrupoEquipamento = val
  }

  @Mutation
  setModal(modal: SetSuporteModal) {
    this.modal[modal.name] = modal.value
  }

  @Mutation
  setHospitalId(value: string) {
    this.hospitalId = value
  }

  @Mutation
  clearHospitalId() {
    this.hospitalId = ''
  }

  @Mutation
  setMode(param: any) {
    this.mode = param.mode
  }

  @Mutation
  clearSearchGrupoEquipamento() {
    this.searchGrupoEquipamento = ''
  }

  @Mutation
  clearSearchEquipamento() {
    this.searchEquipamento = ''
  }

  /** Equipamentos e Grupo de Equipamentos */
  private paginationEquipamentosDefault: DataTablePagination = {
    descending: false,
    page: 1,
    rowsPerPage: 5,
    sortBy: null,
    totalItems: 0,
    rowsPerPageItems: [5, 10, 25],
  }

  private paginationGruposEquipamentosDefault: DataTablePagination = {
    descending: false,
    page: 1,
    rowsPerPage: 5,
    sortBy: null,
    totalItems: 0,
    rowsPerPageItems: [5, 10, 25],
  }

  public paginationEquipamentos: DataTablePagination = { ...this.paginationEquipamentosDefault }

  get paginationEquipDefault() {
    return this.paginationEquipamentosDefault
  }

  get paginationGrupoDefault() {
    return this.paginationGruposEquipamentosDefault
  }

  public paginationGruposEquipamentos: DataTablePagination = { ...this.paginationGruposEquipamentosDefault }

  private equipamentosDefault: EquipamentoHospital[] = []
  private gruposEquipamentosDefault: GrupoEquipamentoHospital[] = []
  private equipamentoDefault: EquipamentoHospital = {
    id: '',
    nome: '',
    status: 'Ativo',
    quantidade: 0,
    hisId: '',
    grupoEquipamentoId: '',
  }

  private grupoEquipamentoDefault: GrupoEquipamentoHospital = {
    id: '',
    nome: '',
    exibeApenasParaOBackoffice: false,
    status: 'Ativo',
    hisId: '',
  }

  public equipamentos: EquipamentoHospital[] = [...this.equipamentosDefault]
  public gruposEquipamentos: GrupoEquipamentoHospital[] = [...this.gruposEquipamentosDefault]
  public gruposDeEquipamentos: GrupoEquipamentoHospital[] = [...this.gruposEquipamentosDefault]
  public equipamento: EquipamentoHospital = { ...this.equipamentoDefault }
  public grupoEquipamento: GrupoEquipamentoHospital = { ...this.grupoEquipamentoDefault }

  @Mutation
  setEquipamentos(value: EquipamentoHospital[]) {
    this.equipamentos = value
  }

  @Mutation
  setEquipamento(value: EquipamentoHospital) {
    this.equipamento = value
  }

  @Mutation
  clearEquipamentos() {
    this.equipamentos = [...this.equipamentosDefault]
  }

  @Mutation
  clearEquipamento() {
    this.equipamento = { ...this.equipamentoDefault }
  }

  @Mutation
  setPaginationEquipamentos(val: DataTablePagination) {
    this.paginationEquipamentos = val
  }

  @Mutation
  setGruposDeEquipamentos(value: GrupoEquipamentoHospital[]) {
    this.gruposDeEquipamentos = value
  }

  @Mutation
  setGruposEquipamentos(value: GrupoEquipamentoHospital[]) {
    this.gruposEquipamentos = value
  }

  @Mutation
  setGrupoEquipamento(value: GrupoEquipamentoHospital) {
    this.grupoEquipamento = value
  }

  @Mutation
  clearGruposEquipamentos() {
    this.gruposEquipamentos = [...this.gruposEquipamentosDefault]
  }

  @Mutation
  clearGruposDeEquipamentos() {
    this.gruposDeEquipamentos = [...this.gruposEquipamentosDefault]
  }

  @Mutation
  clearGrupoEquipamento() {
    this.grupoEquipamento = { ...this.grupoEquipamentoDefault }
  }

  @Mutation
  setPaginationGruposEquipamentos(val: DataTablePagination) {
    this.paginationGruposEquipamentos = val
  }

  @Action
  async getEquipamentoPagedSearch(pagination: DataTablePagination) {
    try {
      const params: any = {
        hospitalId: this.hospitalId,
        pagina: pagination.page || this.paginationEquipamentosDefault.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginationEquipamentosDefault.rowsPerPage,
        searchText: this.searchEquipamento,
      }

      const request = await Apis.Agendamento.SuporteApi.getAllEquipamentosByHospital(params)
      if (request.success) {
        this.context.commit('setEquipamentos', request.data.equipamentos as EquipamentoHospital[] || [])
        this.context.commit('setPaginationEquipamentos', {
          descending: false,
          page: pagination.page || this.paginationEquipamentosDefault.page,
          rowsPerPage: pagination.rowsPerPage || this.paginationEquipamentosDefault.rowsPerPage,
          sortBy: null,
          totalItems: request.data.total,
          rowsPerPageItems: this.paginationEquipamentosDefault.rowsPerPageItems,
        })
      }
      return request
    } catch (error) {
      this.context.commit('setEquipamentos', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getAllGruposDeEquipamentos() {
    try {
      const request = await Apis.Agendamento.SuporteApi.getAllGruposDeEquipamentos(this.hospitalId)
      if (request.success) this.context.commit('setGruposDeEquipamentos', request.data.gruposEquipamentos as GrupoEquipamentoHospital[] || [])
      return request
    } catch (error) {
      this.context.commit('setGruposDeEquipamentos', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async getGrupoEquipamentoPagedSearch(pagination: DataTablePagination) {
    try {
      const params: any = {
        hospitalId: this.hospitalId,
        pagina: pagination.page || this.paginationGruposEquipamentosDefault.page,
        qtdPorPagina: pagination.rowsPerPage || this.paginationGruposEquipamentosDefault.rowsPerPage,
        searchText: this.searchGrupoEquipamento,
      }

      const request = await Apis.Agendamento.SuporteApi.getAllGruposEquipamentosByHospital(params)
      if (request.success) {
        this.context.commit('setGruposEquipamentos', request.data.gruposEquipamentos as GrupoEquipamentoHospital[] || [])
        this.context.commit('setPaginationGruposEquipamentos', {
          descending: false,
          page: pagination.page || this.paginationGruposEquipamentosDefault.page,
          rowsPerPage: pagination.rowsPerPage || this.paginationGruposEquipamentosDefault.rowsPerPage,
          sortBy: null,
          totalItems: request.data.total,
          rowsPerPageItems: this.paginationGruposEquipamentosDefault.rowsPerPageItems,
        })
      }
      return request
    } catch (error) {
      this.context.commit('setGruposEquipamentos', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async upsertEquipamentoByHospital() {
    try {
      const params: any = {
        hospitalId: this.hospitalId,
        ...this.equipamento,
      }

      Object.entries(params).forEach(([key, value]) => {
        // @ts-ignore
        if (['', null, undefined].includes(value)) {
          delete params[key]
        }
      })

      const request = await Apis.Agendamento.SuporteApi.upsertEquipamentoByHospital(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async upsertGrupoEquipamentoByHospital() {
    try {
      const params: any = {
        hospitalId: this.hospitalId,
        ...this.grupoEquipamento,
      }

      Object.entries(params).forEach(([key, value]) => {
        // @ts-ignore
        if (['', null, undefined].includes(value)) {
          delete params[key]
        }
      })

      const request = await Apis.Agendamento.SuporteApi.upsertGrupoEquipamentoByHospital(params)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
